import { render, staticRenderFns } from "./group-relationship-batch-approval.vue?vue&type=template&id=a06456e4"
import script from "./group-relationship-batch-approval.vue?vue&type=script&lang=js"
export * from "./group-relationship-batch-approval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports